import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;

  .ant-form-item {
    width: 100%;
  }
`;

export const TitleWrapper = styled.div`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: ${({ theme }) => theme.colors.black5};
`;

export const ApplicationDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: start;
`;

export const LabelWrapper = styled.div`
  font-weight: 500;
`;

export const SelectorWrapper = styled.div`
  display: flex;
  gap: 4px;

  .ant-form-item {
    align-self: flex-end;
  }
`;
